import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  data: {},
};

for (let i = 0; i < 40; i++) {
  initialState.data[`vinylSlidingInput${i + 1}`] = '';
}

initialState.data['vinylSlidingInput15'] = 0;

export const vinylslidingSlice = createSlice({
  name: 'vinylsliding',
  initialState,
  reducers: {
    updateValue: (state, action) => {
      state.data[action.payload.id] = action.payload.count || '';
    },
    updateDataVinylsliding: (state, action) => {
      let mid = {};
      Object.entries(action.payload).forEach(([k, v]) => (mid[k] = v || ''));
      state.data = mid;
    },
    init: (state, action) => {
      state.data = initialState.data;
    },
  },
});

// Action creators are generated for each case reducer function
export const { updateValue, updateDataVinylsliding, init } =
  vinylslidingSlice.actions;

export default vinylslidingSlice.reducer;
